import { Component } from '@angular/core';
import { CardComponent } from '@shared/components/card/card.component';
import { TranslatePipe } from '@ngx-translate/core';
import { LucideAngularModule, Trash } from 'lucide-angular';
import { ToastService } from '@app/core/services/toast.service';
import { TableConfigService } from '@app/core/services/table-config.service';
import { TableSavedSettings } from '@shared/interfaces/table/table-saved-settings';

@Component({
  selector: 'app-settings-configuration',
  imports: [
    CardComponent,
    TranslatePipe,
    LucideAngularModule
  ],
  templateUrl: './settings-configuration.component.html',
  styleUrl: './settings-configuration.component.css'
})
export class SettingsConfigurationComponent {
  /** Icons **/
  protected readonly Trash = Trash;

  public tableSettings: { tableId: string; settings: TableSavedSettings }[] = [];

  constructor(
    private readonly toastService: ToastService,
    private readonly tableConfigService: TableConfigService,
  ) {
    this.updateConfigList();
  }

  public clearTableConfigurations(): void {
    this.tableConfigService.removeAll();
    this.toastService.show('settings.system.table.reset')
    this.updateConfigList();
  }

  public clearTableConfiguration(tableId: string): void {
    this.tableConfigService.removeSettings(tableId);
    this.updateConfigList();
  }

  public updateConfigList(): void {
    this.tableSettings = [];
    this.tableSettings = this.tableConfigService.fetchAll();
  }

  public removeAll(): void {
    this.tableConfigService.removeAll();
    this.updateConfigList();
  }
}
